import { render, staticRenderFns } from "./VeterinariaTodos.vue?vue&type=template&id=3e7dc5f0&scoped=true&"
import script from "./VeterinariaTodos.vue?vue&type=script&lang=js&"
export * from "./VeterinariaTodos.vue?vue&type=script&lang=js&"
import style0 from "./VeterinariaTodos.vue?vue&type=style&index=0&id=3e7dc5f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7dc5f0",
  null
  
)

export default component.exports